function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { compose, mapProps, withHandlers, withPropsOnChange } from 'recompose';
import { getApplicationAction, getEducationHistoriesAction, getStudentTestScoresAction } from "../../../../api/jsonapi";
import lazyLoad from "../../../../util/lazyLoad";
import { getApiObjectList, showWarningForResidence } from "../../../../util/common";
import componentErrorBoundary from "../../../../components/enhancers/componentErrorBoundary";
import StudentSection from "./StudentSection";
import { formatDate } from '@applyboard/ab-common';
import { omit } from '@applyboard/ui-utils';
var sortSchools = function sortSchools(a, b) {
  if (a["new"] && !b["new"]) return -1;
  if (b["new"] && !a["new"]) return 1;
  return 0;
};
var addressIdSelector = function addressIdSelector(e) {
  try {
    return e.relationships.school_address.data.id;
  } catch (ex) {
    console.error(ex);
  }
  return null;
};
var findAddressWithId = function findAddressWithId(addresses, address_id) {
  if (!addresses || !Array.isArray(addresses)) return null;
  return addresses.find(function (a) {
    return String(a.id) === String(address_id);
  });
};
var enhancer = compose(componentErrorBoundary, lazyLoad('api_education_histories', getEducationHistoriesAction, function (perform, _ref) {
  var student_information_id = _ref.student_information_id;
  return perform({
    student_id: student_information_id,
    include: 'educational_institution,school_address'
  });
}, function (_ref2) {
  var request = _ref2.request,
    student_information_id = _ref2.student_information_id,
    hasPermission = _ref2.hasPermission;
  return (!request || !request.hasStarted) && !!student_information_id && hasPermission('view_education_summary');
}), lazyLoad('api_test_scores', getStudentTestScoresAction, function (perform, _ref3) {
  var student_information_id = _ref3.student_information_id;
  return perform({
    id: student_information_id
  });
}, function (_ref4) {
  var request = _ref4.request,
    student_information_id = _ref4.student_information_id,
    hasPermission = _ref4.hasPermission;
  return (!request || !request.hasStarted) && !!student_information_id && hasPermission('view_test_scores');
}), lazyLoad('api_application', getApplicationAction, function (perform, _ref5) {
  var application = _ref5.application;
  return perform({
    id: application && application.id,
    include: ['agent_representative', 'original_agent_representative', 'student_representative', 'original_student_representative'].join(','),
    'extra_fields[applications]': 'most_recent_note_author_type'
  });
}, function (_ref6) {
  var request = _ref6.request,
    application = _ref6.application;
  return (!request || !request.hasStarted) && !!(application && application.id);
}), getApiObjectList('addresses'), getApiObjectList('sales_representatives'), getApiObjectList('agent_managers'), withPropsOnChange(function (oldProps, nextProps) {
  if (!nextProps.api_education_histories) return false;
  if (!oldProps.api_education_histories) return true;
  if (oldProps.api_education_histories.length !== nextProps.api_education_histories.length) {
    return true;
  }
  return false;
}, function (_ref7) {
  var addresses = _ref7.addresses,
    api_education_histories = _ref7.api_education_histories,
    status = _ref7.status;
  if (!api_education_histories || !addresses || addresses.length <= 0) {
    return {
      schools: []
    };
  }
  var schools = api_education_histories.filter(Boolean).map(function (e) {
    var _status$api_education, _status$api_education2;
    var address_id = addressIdSelector(e);
    var address = findAddressWithId(addresses, address_id);
    return _objectSpread(_objectSpread({}, e.attributes), {}, {
      address: address,
      school_address_id: address_id,
      has_graduated_enabled: status === null || status === void 0 ? void 0 : (_status$api_education = status.api_education_histories) === null || _status$api_education === void 0 ? void 0 : (_status$api_education2 = _status$api_education.meta) === null || _status$api_education2 === void 0 ? void 0 : _status$api_education2.application_has_graduated_flag_enabled
    });
  }).sort(sortSchools);
  return {
    schools: schools
  };
}), withPropsOnChange(['api_application'], function (_ref8) {
  var sales_representatives = _ref8.sales_representatives,
    agent_managers = _ref8.agent_managers,
    api_application = _ref8.api_application;
  var salesRepId = null;
  var originalSalesRepId = null;
  var label = 'Representative';
  var salesRep;
  var originalSalesRep;
  if (api_application !== null && api_application !== void 0 && api_application.relationships) {
    if (api_application.relationships.agent_representative.data) {
      label = 'Recruitment Partner Representative';
      salesRepId = String(api_application.relationships.agent_representative.data.id);
      if (api_application.relationships.original_agent_representative.data) {
        originalSalesRepId = String(api_application.relationships.original_agent_representative.data.id);
      }
      salesRep = agent_managers.find(function (sr) {
        return String(sr.id) === salesRepId;
      });
      originalSalesRep = agent_managers.find(function (osr) {
        return String(osr.id) === originalSalesRepId;
      });
    } else if (api_application.relationships.student_representative.data) {
      label = 'Student Representative';
      salesRepId = String(api_application.relationships.student_representative.data.id);
      if (api_application.relationships.original_student_representative.data) {
        originalSalesRepId = String(api_application.relationships.original_student_representative.data.id);
      }
      salesRep = sales_representatives.find(function (sr) {
        return String(sr.id) === salesRepId;
      });
      originalSalesRep = sales_representatives.find(function (osr) {
        return String(osr.id) === originalSalesRepId;
      });
    }
  }
  return {
    originalSalesRep: originalSalesRep,
    salesRep: salesRep,
    salesRepTitle: label,
    showOriginalRep: originalSalesRepId !== salesRepId && !!originalSalesRep,
    showReps: !!salesRep
  };
}), withPropsOnChange(['api_test_scores'], function (_ref9) {
  var api_test_scores = _ref9.api_test_scores;
  var english_score = api_test_scores && api_test_scores.find(function (test) {
    return test.attributes.category === 'lang-english';
  });
  var formatted_engish_score = null;
  if (english_score) {
    formatted_engish_score = _objectSpread(_objectSpread({}, english_score.attributes.scores), {}, {
      exam_date: english_score.attributes.exam_date,
      type: english_score.attributes.display_name,
      verified: english_score.attributes.verified,
      verified_ielts_score: english_score.attributes.verified_ielts_score
    });
  }
  var additional_tests = api_test_scores && api_test_scores.filter(function (test) {
    return test.attributes.category === 'graduate';
  }).reduce(function (acc, cur) {
    acc[cur.attributes.name] = _objectSpread(_objectSpread({}, cur.attributes.scores), {}, {
      exam_date: cur.attributes.exam_date
    });
    return acc;
  }, {});
  var testScores = _objectSpread({
    additionalQualifications: _objectSpread({}, additional_tests)
  }, formatted_engish_score);
  return {
    testScores: testScores
  };
}), withPropsOnChange(['application'], function (_ref10) {
  var application = _ref10.application;
  var info = {};
  var address = {};
  if (application && application.student) {
    var student = application.student,
      status = application.status;
    var student_birthdate = student && student.personal_information && student.personal_information.birthdate;
    var residential_address = student && student.residential_address && student.residential_address.address;
    var passportExpiryDate = student && student.personal_information && student.personal_information.passport_expiry_date;
    info = _objectSpread(_objectSpread(_objectSpread({}, student.personal_information), {}, {
      studentId: student.id,
      email: student.email,
      email_validation: student.email_validation,
      birthday: formatDate(student_birthdate, 'MMMM DD, YYYY'),
      passportExpiryDay: formatDate(passportExpiryDate, 'MMMM DD, YYYY')
    }, student.education_summary), {}, {
      profileLink: student.student_link,
      status: _objectSpread({}, status)
    });
    address = _objectSpread({}, residential_address);
  }
  var school = application && application.school && Object.keys(application.school).length > 0 ? application.school : null;
  var submission_through = school && school.submission_through;
  var showWarningForResidenceUtil = showWarningForResidence(application);
  return {
    address: address,
    application: application,
    info: info,
    school: school,
    showWarningForResidenceUtil: showWarningForResidenceUtil,
    submission_through: submission_through
  };
}), withHandlers({
  onSubmittedToSchool: function onSubmittedToSchool(_ref11) {
    var onSubmittedToSchoolClick = _ref11.onSubmittedToSchoolClick,
      application = _ref11.application;
    return function () {
      return onSubmittedToSchoolClick(!application.status.submitted);
    };
  },
  onReadyToSubmit: function onReadyToSubmit(_ref12) {
    var onReadyToSubmitClick = _ref12.onReadyToSubmitClick,
      application = _ref12.application;
    return function () {
      return onReadyToSubmitClick(!application.status.ready_to_submit);
    };
  },
  onReadyForVisa: function onReadyForVisa(_ref13) {
    var onReadyForVisaClick = _ref13.onReadyForVisaClick,
      application = _ref13.application;
    return function (value, extra) {
      return onReadyForVisaClick(!application.status.ready_for_visa, extra);
    };
  },
  refetchTestScores: function refetchTestScores(_ref14) {
    var status = _ref14.status;
    return function () {
      status.api_test_scores.invalidate();
    };
  }
}), mapProps(function (props) {
  return omit(props, ['status']);
}));
export default enhancer(StudentSection);